import React, { Component } from 'react';

export class SpeedControl extends Component {

    render() {

        return(
            <p>
                <label>{this.props.label}</label>
                <select onChange={this.props.onChange}>
                    <option value={1.0}>Medium</option>
                    <option value={this.props.min}>Slow</option>
                    <option value={this.props.max}>Fast</option>
                </select>
            </p>
        )
    }


}